import React from 'react'
import UpdateSingleTeam from '../../../features/team/components/UpdateSingleTeam'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'

export default function UpdateTeamPage() {
  return (
    <PageLayout 
      showBackButton
    >
      <UpdateSingleTeam.Form/>
    </PageLayout>
  )
}
